import { useEffect, useState } from "react";
import { Activity, Globe, Zap, Building2, BookOpen, Award } from "lucide-react";
import { getPublicStats } from "@/lib/api";

/**
 * Live Counter — homepage social proof ticker.
 * Polls every 30s. Renders nothing on first failure so the page doesn't shift.
 */
export default function LiveCounter() {
    const [stats, setStats] = useState(null);

    useEffect(() => {
        let active = true;
        const fetchStats = async () => {
            try {
                const d = await getPublicStats();
                if (active) setStats(d);
            } catch {
                /* swallow */
            }
        };
        fetchStats();
        const id = setInterval(fetchStats, 30000);
        return () => {
            active = false;
            clearInterval(id);
        };
    }, []);

    if (!stats) return null;

    const items = [
        { Icon: Activity, label: "CASES ANALYSED", value: stats.cases_analysed, accent: "#FF3B30" },
        { Icon: Zap, label: "BOTS ONLINE", value: `${stats.bots_online} / 10`, accent: "#FFCC00" },
        { Icon: Award, label: "LEADS CONNECTED", value: stats.leads_connected, accent: "#FF3B30" },
        { Icon: Building2, label: "VETTED FIRMS", value: stats.vetted_firms, accent: "#FFCC00" },
        { Icon: BookOpen, label: "LEGAL GUIDES", value: stats.blog_posts, accent: "#FF3B30" },
        { Icon: Globe, label: "LANGUAGES", value: stats.languages_supported, accent: "#FFCC00" },
    ];

    return (
        <div className="border-y-2 border-white/20 bg-[#0a0a0a]" data-testid="live-counter">
            <div className="max-w-[1600px] mx-auto px-4 sm:px-10">
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-0">
                    {items.map((it, i) => {
                        const Icon = it.Icon;
                        return (
                            <div
                                key={i}
                                className={`p-4 sm:p-5 flex items-center gap-3 ${i % 2 === 1 ? "lg:border-l-2" : ""} ${i >= 2 && i % 2 === 0 ? "sm:border-l-2" : ""} sm:[&:not(:nth-child(3n))]:border-l-2 lg:[&:not(:nth-child(6n))]:border-l-2 border-white/20`}
                                data-testid={`live-counter-${i}`}
                            >
                                <Icon size={18} style={{ color: it.accent }} className="flex-shrink-0" />
                                <div className="min-w-0">
                                    <div className="font-anton text-2xl sm:text-3xl leading-none">
                                        {it.value}
                                    </div>
                                    <div className="font-mono text-[9px] sm:text-[10px] uppercase tracking-[0.25em] text-white/50 mt-1 truncate">
                                        {it.label}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
